module.exports = __webpack_public_path__ + "static/img/qdcg.20090f94.png";